export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            关于极速影院
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-movie-2-fill text-background-50 text-3xl"></i>
            </div>
          </div>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-center max-w-2xl mx-auto">
            极速影院创立于2024年，是一家专注于免费综艺节目在线观看的平台。我们致力于为观众提供高清、流畅、全面的综艺娱乐体验。
            从音乐竞技到户外真人秀，从脱口秀到选秀才艺，极速影院汇聚了全网最新最热的综艺节目资源。
            我们相信，好的综艺节目应该被更多人看到——无需付费，无需门槛，打开极速影院，精彩即刻呈现。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-8">
            {[
              { value: '2000+', label: '综艺节目' },
              { value: '50万+', label: '日活跃用户' },
              { value: '1080P', label: '超清画质' },
              { value: '7×24', label: '持续运营' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <p className="text-2xl font-black text-primary-600 font-heading">{stat.value}</p>
                <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}